var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"btn blue darken-3",attrs:{"to":_vm.link}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")])])}
var staticRenderFns = []

export { render, staticRenderFns }